// MainLayout.jsx
import React from "react";
import PropTypes from "prop-types";
import { Header } from '../Header';
import { LayoutWithSidebar } from '../LayoutWithSidebar';
import './MainLayout.styles.scss';

/**
 * MainLayout component that serves as the primary layout structure for the application.
 * Can render with or without a sidebar and header based on props.
 */
const MainLayout = ({
  children,
  loading = false,
  tab,
  withSidebar = false,
  hideHeader = false // New prop to hide header
}) => {
  return (
    <div className="layout">
      {/* Conditionally render header */}
      {!hideHeader && (
        <div className="layout__header-container">
          <Header tab={tab} />
        </div>
      )}
      
      {withSidebar ? (
        <LayoutWithSidebar
          tab={tab}
          className="layout__content"
        >
          {loading ? <div className="layout__loader">Loading...</div> : children}
        </LayoutWithSidebar>
      ) : (
        <main className={`layout__content ${hideHeader ? 'layout__content--no-header' : ''}`}>
          {loading ? <div className="layout__loader">Loading...</div> : children}
        </main>
      )}
    </div>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool,
  tab: PropTypes.string,
  withSidebar: PropTypes.bool,
  hideHeader: PropTypes.bool // Add new prop type
};

export default React.memo(MainLayout);